import axios from 'axios';
import Config from '../../config-app/config'
import * as ResponseTransformers from "./responseTransformers";


export const getMainStatus = async () => {
  try {
    const response = await axios.get(Config.CDN_API_ENDPOINT + "/mainStatus.php");
    const data = handleResponse(response);
    return ResponseTransformers.msCalciatori(data);
  } catch (error) {
    console.error('Status calciatore (cerchio a destra del calciatore) non disponibile al momento.', error.message);
  }
};

const handleResponse = (response) => {
  if (response.status === 200) {
    if (response.data.status == 1) {
      return response.data.data
    } else {
      throw new Error(`${response.data.msg}`);
    }
  } else {
    throw new Error(`Unexpected status code: ${response.status}`);
  }
};

// api mixins
// import toast from "./toast";
// export default {
//   mixins: [toast],
//   methods: {
//     async getMainStatus() {
//       try {
//         const response = await axios.get(Config.CDN_API_ENDPOINT + "/mainStatus.php");
//         const data = handleResponse(response);
//         return ResponseTransformers.msCalciatori(data);
//       } catch (error) {
//         this.errorToast('Pallino status calciatore non disponibile al momento', error.message);
//       }
//     },

//     handleResponse(response) {
//       if (response.status !== 200) {
//         if (response.data.status == 1) {
//           return response.data.data
//         } else {
//           console.error('error', response.data.msg);
//         }
//       } else {
//         throw new Error(`Unexpected status code: ${response.status}`);
//       }
//     }
//   }
// }
